<script lang="ts">
    import {onMount} from "svelte";
    import {allUnits} from "$lib/stores/unit";
    import {getUnits} from "$lib/calls/unit";
    import SortableTable from "$lib/components/SortableTable.svelte";
    import EditButton from "$lib/components/ui/EditButton.svelte";
    import UnitEditModal from "$lib/partials/settings/UnitEditModal.svelte";
    import {Search} from "flowbite-svelte";

    let open = false;
    let currentUnit: any = null;

    let search = '';

    const openEditModal = (unit: any) => {
        currentUnit = unit;
        open = true
    }

    const header = [
        {
            property: 'name',
            label: 'Name',
            sortable: true
        },{
            property: 'address',
            label: 'Adresse',
            render: (item: any) => {
                return item.address ? `${item.address.street} ${item.address.number}, ${item.address.zip} ${item.address.place}` : '<span class="text-red-500">Keine Adresse vergeben</span>'
            }
        },{
            property: 'email',
            label: 'E-Mail',
            render: (item: any) => {
                return item.email ? item.email : '<span class="text-red-500">Keine E-Mail vergeben</span>'
            }
        },{
            property: 'id',
            label: 'Actions',
            component: EditButton,
            props: {
                onClick: (id: number) => {
                    openEditModal($allUnits.find(x => x.id === id))
                }
            }

        }
    ]

    onMount(async ()=> {
        if($allUnits.length === 0) {
            $allUnits = await getUnits();
        }
    })
</script>
<svelte:head><title>Units</title></svelte:head>
<Search bind:value={search}/>
<SortableTable data={$allUnits.filter(x => x.name.toLowerCase().includes(search.toLowerCase()))} {header} />
<UnitEditModal unit={currentUnit} bind:open/>